import React, { useState } from 'react';
import { type Door } from '../App';
type CreateReaderFormProps = {
  onSubmit: (reader: {
    name: string;
    description: string;
    doorControlUnit: string;
    vgunterNode: string;
    accessFunction: string;
  }) => void;
  doors: Door[];
};
const CreateReaderForm = ({
  onSubmit,
  doors
}: CreateReaderFormProps) => {
  const [formData, setFormData] = useState({
    name: '',
    description: '',
    doorControlUnit: '',
    vgunterNode: '',
    accessFunction: '',
    doorId: ''
  });
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const {
      doorId,
      ...readerData
    } = formData;
    onSubmit(readerData);
  };
  const isFormValid = () => {
    return formData.name.trim() !== '' && formData.doorControlUnit.trim() !== '' && formData.vgunterNode.trim() !== '' && formData.accessFunction.trim() !== '';
  };
  return <form onSubmit={handleSubmit} className="space-y-4" data-id="element-8">
      <div data-id="element-9">
        <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-10">
          Reader Name *
        </label>
        <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:ring-blue-500 focus:border-blue-500" placeholder="Enter reader name" required data-id="element-11" />
      </div>
      <div data-id="element-12">
        <label htmlFor="description" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-13">
          Description
        </label>
        <textarea id="description" name="description" value={formData.description} onChange={handleChange} rows={3} className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:ring-blue-500 focus:border-blue-500" placeholder="Enter description (optional)" data-id="element-14" />
      </div>
      <div data-id="element-15">
        <label htmlFor="doorId" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-16">
          Door
        </label>
        <select id="doorId" name="doorId" value={formData.doorId} onChange={handleChange} className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:ring-blue-500 focus:border-blue-500" data-id="element-17">
          <option value="" data-id="element-18">-- Select Door --</option>
          {doors.map(door => <option key={door.id} value={door.id} data-id="element-19">
              {door.name}
            </option>)}
        </select>
      </div>
      <div data-id="element-20">
        <label htmlFor="doorControlUnit" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-21">
          Door Control Unit *
        </label>
        <input type="text" id="doorControlUnit" name="doorControlUnit" value={formData.doorControlUnit} onChange={handleChange} className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:ring-blue-500 focus:border-blue-500" placeholder="Enter door control unit" required data-id="element-22" />
      </div>
      <div data-id="element-23">
        <label htmlFor="vgunterNode" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-24">
          Weigand Terminal *
        </label>
        <input type="text" id="vgunterNode" name="vgunterNode" value={formData.vgunterNode} onChange={handleChange} className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:ring-blue-500 focus:border-blue-500" placeholder="Enter weigand terminal" required data-id="element-25" />
      </div>
      <div data-id="element-26">
        <label htmlFor="accessFunction" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-27">
          Access Point *
        </label>
        <select id="accessFunction" name="accessFunction" value={formData.accessFunction} onChange={handleChange} className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:ring-blue-500 focus:border-blue-500" required data-id="element-28">
          <option value="" data-id="element-29">-- Select Access Point --</option>
          {doors.map(door => <option key={door.id} value={door.name} data-id="element-30">
              {door.name}
            </option>)}
        </select>
      </div>
      <div className="pt-4" data-id="element-31">
        <button type="submit" disabled={!isFormValid()} className={`w-full py-3 px-4 rounded-lg text-white font-medium ${isFormValid() ? 'bg-blue-600 hover:bg-blue-700 active:bg-blue-800' : 'bg-gray-400 cursor-not-allowed'}`} data-id="element-32">
          Create Logical Reader
        </button>
      </div>
    </form>;
};
export default CreateReaderForm;